"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toolbar = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdFormik = require("cccisd-formik");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var toolbar = ['styleselect bold italic underline | charmap | link unlink | forecolor backcolor | bullist numlist outdent indent | code | cccisdImageResource cccisdTooltip cccisdInformation cccisdIcons'];
exports.toolbar = toolbar;
var InlineWysiwyg = function InlineWysiwyg(props) {
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, _extends({}, props, {
    component: _cccisdFormik.CccisdWysiwyg,
    type: "input",
    settings: {
      toolbar: toolbar
    }
  }));
};
InlineWysiwyg.propTypes = {
  name: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string
};
var _default = InlineWysiwyg;
exports["default"] = _default;